import { useId } from 'react';

interface SpotlightProps {
  /** Anchor rect in viewport coordinates. */
  readonly rect: DOMRect;
  /** Padding around the anchor inside the cutout. */
  readonly padding?: number;
}

/**
 * Full-viewport SVG mask that dims everything except a rounded-rect cutout
 * around the anchor. `pointer-events-none` so clicks reach the anchor.
 */
export function Spotlight({ rect, padding = 8 }: SpotlightProps) {
  const maskId = useId();
  const x = rect.left - padding;
  const y = rect.top - padding;
  const width = rect.width + padding * 2;
  const height = rect.height + padding * 2;

  return (
    <svg
      className="pointer-events-none fixed inset-0 h-full w-full"
      aria-hidden="true"
      role="presentation"
    >
      <defs>
        <mask id={maskId}>
          <rect width="100%" height="100%" fill="white" />
          <rect x={x} y={y} width={width} height={height} rx={8} ry={8} fill="black" />
        </mask>
      </defs>
      <rect width="100%" height="100%" mask={`url(#${maskId})`} className="fill-black/60" />
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        rx={8}
        ry={8}
        className="fill-none stroke-white/80"
        strokeWidth={2}
      />
    </svg>
  );
}
